module.exports = __webpack_public_path__ + "01_veryshort_gold.57c7b139.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/kanai/male/layer5/01_veryshort_gold.png
// module id = blL1
// module chunks = 0